export default "__VITE_ASSET__66de5d65__"